import logger from '../utils/rbmc.logger';
import personalizeService from '../utils/rbmc.personalizeService';
import gigyaCustom from './rbmc.gigya';
import rbmcGigya from './rbmc.gigya';
import contestQuestions from './rbmc.contestQuestions';

const gigyaLiteRegistration = {
    CDC_PENDING_SUBSCRIPTION:                 'subscribed_pending',
    CDC_SUBSCRIBE_WITH_EMAIL_SCREEN:          'gigya-subscribe-with-email-screen',
    CDC_SUBSCRIBE_IN_STORE_WITH_EMAIL_SCREEN: 'gigya-subscribe-with-physical-store-email-screen',
    CDC_CONTEST_PARTICIPATION_PREFIX:         'gigya-contest',
    GIGYA_DIV_WRAPPER:                        `<div class="gigya-composite-control gigya-composite-control--wrapper"></div>`,
    NEWSLETTER_SVG_HTML:                      `<svg class="icon icon-delivery account-navigation__headline-icon">
                                                <use xlink:href="#icon-email"></use>
                                              </svg>`,
    NEWSLETTER_INTERESTS_TITLE:               `<div class="newsletter-interests-title--wrapper"></div>`,

    bindHandler: () => {
        document.addEventListener('gigya-lite-registration-after-screenload', gigyaLiteRegistration.onScreenLoaded);
        document.addEventListener('gigya-lite-registration-after-submit', gigyaLiteRegistration.onAfterSubmit);
        document.addEventListener('gigya-lite-registration-on-submit', gigyaLiteRegistration.registrationSubmit);
    },

    onScreenLoaded: evt => {
        const currentScreen = evt.detail.currentScreen;
        switch (currentScreen) {
                /**
                 * Case if classic newsletter registration is used
                 */
            case gigyaLiteRegistration.CDC_SUBSCRIBE_WITH_EMAIL_SCREEN:
                const liteScreensetForm = $('#cdc-gigya-subscribe-with-email-container');
                const emailField        = liteScreensetForm.find('[name="profile.email"]');
                const nameField         = liteScreensetForm.find('[name="profile.firstName"]');
                const genderField       = liteScreensetForm.find('[name="profile.gender"]');
                const languageField     = liteScreensetForm.find('[name="data.ns.language"]');

                emailField.prop('disabled', true);
                nameField.prop('disabled', true);
                genderField.prop('disabled', true);

                personalizeService.getPersonalizedData().then((data) => {
                    if (data.loginState === '0') {
                        emailField.prop('disabled', false);
                        nameField.prop('disabled', false);
                        genderField.prop('disabled', false);
                    }
                });

                /**
                 * Extract user email address from URL and prefill it in CDC form
                 */
                const userEmail = new URL(window.location.href).searchParams.get('email');

                rbmcGigya.isGigyaUserAuthenticated().then((isLoggedIn) => {
                    if (!isLoggedIn) {
                        emailField.val(userEmail);
                    }
                });

                gigyaLiteRegistration.languagePrefill(languageField);
                gigyaLiteRegistration.wrapDateFields(liteScreensetForm);
                gigyaLiteRegistration.addDateDots(liteScreensetForm);

                // Existing newsletter registration check
                const $registerForm = liteScreensetForm.find('.gigya-subscribe-with-email-form');
                const $emailInput   = $registerForm.find('input[name="profile.email"]');
                const $submitButton = $registerForm.find('.gigya-input-submit');
                gigyaLiteRegistration.newsletterCheck($registerForm, $emailInput, $submitButton);

                break;
                /**
                 * Case if in-store newsletter registration is used
                 */
            case gigyaLiteRegistration.CDC_SUBSCRIBE_IN_STORE_WITH_EMAIL_SCREEN:
                const liteNewsletterInStoreScreensetForm = $('#cdc-gigya-subscribe-in-store-with-email-container');
                const languageInStoreField               = liteNewsletterInStoreScreensetForm.find('[name="data.ns.language"]');
                const storeIDField                       = liteNewsletterInStoreScreensetForm.find('[name="data.storeId"]');
                const storeId                            = $('.js-physical-store').data('store-id');

                if (storeId !== undefined) {
                    window.localStorage.setItem('storeId', storeId);
                    storeIDField.val(storeId);
                }

                gigyaLiteRegistration.languagePrefill(languageInStoreField);
                gigyaLiteRegistration.wrapDateFields(liteNewsletterInStoreScreensetForm);
                gigyaLiteRegistration.addDateDots(liteNewsletterInStoreScreensetForm);

                // Existing newsletter registration check
                const $registerFormInStore = liteNewsletterInStoreScreensetForm.find('.gigya-subscribe-with-email-form');
                const $emailInputInStore   = $registerFormInStore.find('input[name="profile.email"]');
                const $submitButtonInStore = $registerFormInStore.find('.gigya-input-submit');
                gigyaLiteRegistration.newsletterCheck($registerFormInStore, $emailInputInStore, $submitButtonInStore);

                break;

                /**
                 * Case if user applies n contest and newsletter registration is used
                 */
            case (currentScreen.startsWith(gigyaLiteRegistration.CDC_CONTEST_PARTICIPATION_PREFIX) ? currentScreen : false) :
                // Call caching methods if component exsists
                if ($('.contest-page__questions').length) {
                    contestQuestions.init();
                }

                const contestForm          = $('[id^=cdc-gigya-contest] form'),
                      emailContestField    = contestForm.find('[name="profile.email"]'),
                      nameContestField     = contestForm.find('[name="profile.firstName"]'),
                      lastNameContestField = contestForm.find('[name="profile.lastName"]'),
                      genderContestField   = contestForm.find('[name="profile.gender"]'),
                      languageContestField = contestForm.find('[name="data.ns.language"]');

                emailContestField.prop('disabled', true);
                nameContestField.prop('disabled', true);
                lastNameContestField.prop('disabled', true);
                genderContestField.prop('disabled', true);

                personalizeService.getPersonalizedData().then((data) => {
                    if (data.loginState === '0') {
                        emailContestField.prop('disabled', false);
                        nameContestField.prop('disabled', false);
                        lastNameContestField.prop('disabled', false);
                        genderContestField.prop('disabled', false);
                    }
                });

                gigyaLiteRegistration.languagePrefill(languageContestField);
                gigyaLiteRegistration.wrapDateFields(contestForm);
                gigyaLiteRegistration.addDateDots(contestForm);
                break;
            default:
                logger.log(`Screenset ${evt.detail.currentScreen} has no logic for onScreenLoaded event`);
        }
    },

    /**
     *  Adjust structure for better styling
     *  Wraps all date elements in div with class gigya-control--date-wrapper
     * @param jQuery element
     */
    wrapDateFields: $element => {
        $element.find('[class*="birth"]')
                .wrapAll('<div class="gigya-control--date-wrapper"></div>');
        $element.find('.wrap-element-date').wrapAll('<div class="registration-nl__date-fields">');
    },

    /**
     * Prefill newsletter language based on current shop language
     * @param jQuery element
     */

    languagePrefill: $field => {
        $field.find(`option[value="${RedBull.config.language}"]`) ? $field.val(RedBull.config.language) : $field.val('en');
    },

    /**
     * Appends dots for date fields, requires form to be passwd as argument
     * @param $screensetForm
     */
    addDateDots($screensetForm) {
        $screensetForm.find('.wrap-element-date:not(:last-child)').after('<span class="date-delimiter"></span>');
    },

    /**
     * Extracts X-NC-geoip and X-NC-geocity cookie values from personalize request and attaches it to the current screen data object
     * @param event
     */
    setAdditionalGeoDetails: event => {
        if (event.detail.screen !== gigyaLiteRegistration.CDC_SUBSCRIBE_IN_STORE_WITH_EMAIL_SCREEN) {
            const profileData = event.detail.formModel.profile;
            if (profileData) {
                personalizeService.getPersonalizedData().then((data) => {
                    profileData.country = data.countryFromCookie;
                    profileData.city    = data.cityFromCookie;
                });
            }
        }
    },

    registrationSubmit: event => {
        gigyaCustom.clearUncheckedSubscriptions(event);
        gigyaLiteRegistration.setAdditionalGeoDetails(event);
        gigyaCustom.clearEmailForLoggedIn(event);
        contestQuestions.injectContestSubscriptionTagData(event);
        gigyaLiteRegistration.setPhysicalStoreIdForContest(event);
    },

    /**
     * If store id is defined in url during contest participation, store it on user
     * @param event
     */
    setPhysicalStoreIdForContest: event => {
        if (event.detail.screen.includes(gigyaLiteRegistration.CDC_CONTEST_PARTICIPATION_PREFIX)) {
            const formData = event.detail.formModel.data;
            if (formData) {
                gigyaLiteRegistration.getStoreIdForContest().then((data) => {
                    if (data !== '') {
                        formData.storeId = data;
                    }
                });
            }
        }
    },

    /**
     * Check if store Id from url is one that exist in our data base
     */
    getStoreIdForContest: function () {
        const contestStoreId = new URL(window.location.href).searchParams.get('storeid');
        return $.get(`${ACC.config.encodedContextPath}/contest/physical-store/`, {
            contestStoreId: contestStoreId,
        });
    },

    fetchSubscriptionData(emailInput) {
        return $.ajax({
            url: `${ACC.config.encodedContextPath}/gigyaraas/isSubscribed?email=${emailInput}`, method: 'POST'
        });
    },

    alreadySubscribedActions(response, email) {
        gigyaCustom.renderGlobalMessages(response.message);
        if (response.subscriptionState === gigyaLiteRegistration.CDC_PENDING_SUBSCRIPTION) {
            // If user is subscribed but still in pending state
            gigyaLiteRegistration.triggerDoiResend(email.val());
        }
    },

    newsletterCheck($registerForm, $emailInput, $submitButton) {
        /**
         * IMPLEMENTATION ON CDC SIDE
         * Screen-set: RBMC-LiteRegistration
         * JS METHOD: onBeforeSubmit
         * Contact point: window.allowSubmitSubscribeInStore
         * Description: We are preventing form submit using allowSubmitSubscribeInStore flag
         */
        let checkDone = false;
        window.allowSubmitSubscribeInStore = false;
        if ($registerForm.length) {
            //When email change happens, block submit
            $emailInput.on('blur', function () {
                checkDone = false;
                $submitButton.removeAttr('disabled');
            });

            // Bind submit event and prevent it until email is checked
            $registerForm.on('submit', function (event) {
                if (!$emailInput.hasClass('.gigya-error')) {
                    if (!checkDone) {
                        const request = gigyaLiteRegistration.fetchSubscriptionData($emailInput.val());

                        request.done((response) => {
                            checkDone = true;
                            if (!response.allowSubscription) {
                                // If user is subscribed
                                gigyaCustom.renderGlobalMessages(response.message);
                                $('html, body').animate({
                                    scrollTop: 0
                                }, 200);
                                if (response.subscriptionState === gigyaLiteRegistration.CDC_PENDING_SUBSCRIPTION) {
                                    // If user is subscribed but still in pending state
                                    gigyaLiteRegistration.triggerDoiResend($emailInput.val());
                                }
                                $submitButton.attr('disabled', 'disabled');
                            } else {
                                window.allowSubmitSubscribeInStore = true;
                                $submitButton.trigger('click');
                            }
                        });
                    }
                }
            });
        }
    },

    triggerDoiResend(email) {
        const requestDoi = $.ajax({
            url:    `${ACC.config.encodedContextPath}/gigyaraas/resendDOIConfirmationEmail?email=${email}&subscriptionId=newsletter`,
            method: 'POST',
        });

        requestDoi.done(() => {
            logger.log('TRIGGERED : /resendDOIConfirmationEmail');
        });
    },

    onAfterSubmit: evt => {
        if ('detail' in evt) {
            const data = evt.detail, cdcResponseStatus = data.response.status;
            // an error on form validation occurred
            if (cdcResponseStatus === 'FAIL') {
                // do nothing, form should show error message
                return false;
            } else if (cdcResponseStatus === 'OK') {
                if (data.screen === gigyaLiteRegistration.CDC_SUBSCRIBE_WITH_EMAIL_SCREEN) {
                    window.location.href = `${ACC.config.encodedContextPath}/newsletter/confirmation`;
                }
                if (data.screen.includes(gigyaLiteRegistration.CDC_CONTEST_PARTICIPATION_PREFIX)) {
                    window.location.href = `${ACC.config.encodedContextPath}/newsletter/confirmation?type=contest`;
                }
                if (data.screen === gigyaLiteRegistration.CDC_SUBSCRIBE_IN_STORE_WITH_EMAIL_SCREEN) {
                    window.location.href = `${ACC.config.encodedContextPath}/newsletter/subscribe-in-store/confirmation`;
                }
            } else {
                logger.log(`Error: unexpected status returned from CDC server, response is ${cdcResponseStatus}`);
            }
        }
    }
};

export default gigyaLiteRegistration;
